import { React } from '../libraries';
const SignUp = React.lazy(() => import('../components/signUp/signUpForm.js'));
const SignIn = React.lazy(() => import('../components/login/signIn.js'))
const ForgotPasswordPage = React.lazy(() => import('../common/forgotPassword/forgotPasswordPage.js'));
export {
    SignUp,
    SignIn,
    ForgotPasswordPage
}